<script setup lang="ts">
const { size = 100 } = defineProps<{ size?: number }>();
</script>
<template>
  <div class="loader" :style="`width: ${size}px`"></div>
</template>
<style lang="css">
.loader {
  aspect-ratio: 1;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #ffa516 94%, #0000) top/16px 16px no-repeat,
    conic-gradient(#0000 30%, #ffa516);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 16px), #000 0);
  animation: l13 1s infinite linear;
}
@keyframes l13 {
  100% {
    transform: rotate(1turn);
  }
}
</style>
